import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function InstructionsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Instructions />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Instructions />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Instructions />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Instruction match={ match } history={ history } exact /> }
            </Route>
        </Switch>
    );
}